import {
  viewDataFormatted,
  viewListFormatted,
  viewPageFormatted,
  viewItemFormatted,
} from '@/js/utils';
import Vue from 'vue';

const SET_PROMISE = (state, { promise, uid }) => {
  state.promise[uid] = promise;
};

const SET_MY_LIST = (state, payload) => {
  state.myList = viewListFormatted(payload);
};

const SET_SHARED_LIST = (state, payload) => {
  state.sharedList = viewListFormatted(payload);
};

const SET_SHARED_FULL_VIEW = (state, payload) => {
  const viewIndex = state.sharedMaker.findIndex(
    (view) => view.view_id === payload.view_id
  );
  const val = viewDataFormatted(payload);
  if (viewIndex === -1) {
    state.sharedMaker.push(val);
  } else {
    Vue.set(state.sharedMaker, viewIndex, val);
  }
};

const SET_FULL_VIEW = (state, payload) => {
  const viewIndex = state.myMaker.findIndex(
    (view) => view.view_id === payload.view_id
  );
  const val = viewDataFormatted(payload);
  if (viewIndex === -1) {
    state.myMaker.push(val);
  } else {
    Vue.set(state.myMaker, viewIndex, val);
  }
};

const SET_MY_VIEW = (state, { body }) => {
  const val = viewDataFormatted(body);
  if (!val.view_id) return;
  const lst = viewListFormatted([body]).pop();
  const listIndex = state.myList.findIndex(
    (view) => view.view_id === body.view_id
  );
  if (listIndex === -1) {
    state.myList.push(lst);
  } else {
    Vue.set(state.myList, listIndex, lst);
  }

  const viewIndex = state.myMaker.findIndex(
    (view) => view.view_id === body.view_id
  );
  val.pages =
    val.pages || (viewIndex !== -1 ? state.myMaker[viewIndex].pages : []);
  if (viewIndex === -1) {
    state.myMaker.push(val);
  } else {
    Vue.set(state.myMaker, viewIndex, val);
  }
};

const REMOVE_MY_VIEW = (state, { view_id }) => {
  const viewIndex = state.myMaker.findIndex((view) => view.view_id === view_id);
  if (viewIndex !== -1) state.myMaker.splice(viewIndex, 1);

  const listIndex = state.myList.findIndex((v) => v.view_id === view_id);
  if (listIndex !== -1) state.myList.splice(listIndex, 1);

  const shareIndex = state.shareUser.findIndex(
    (view) => view.view_id === view_id
  );
  if (shareIndex !== -1) state.shareUser.splice(shareIndex, 1);
};

const SET_VIEW_PAGE = (state, { view_id, body }) => {
  const view = state.myMaker.find((view) => view.view_id === view_id);
  if (!view) return;
  const pageList = viewPageFormatted(body);

  pageList.forEach((page) => {
    const pageIndex = view.pages.findIndex((i) => i.page_id === page.page_id);
    page.items =
      page.items || (pageIndex !== -1 ? view.pages[pageIndex].items : []);
    if (pageIndex === -1) view.pages.push(page);
    else {
      Vue.set(view.pages, pageIndex, page);
    }
  });
};

const REMOVE_VIEW_PAGE = (state, { view_id, page_id }) => {
  const view = state.myMaker.find((view) => view.view_id === view_id);
  if (view) {
    const pageIndex = view.pages.findIndex((page) => page.page_id === page_id);
    if (pageIndex !== -1) view.pages.splice(pageIndex, 1);
  }
};

const SET_PAGE_ITEM = (state, { view_id, page_id, body }) => {
  const view = state.myMaker.find((view) => view.view_id === view_id);
  if (!view) return;
  const page = view.pages.find((page) => page.page_id === page_id);

  if (!page) return;
  const itemList = viewItemFormatted(body);

  itemList.forEach((item) => {
    const itemIndex = page.items.findIndex((i) => i.item_id === item.item_id);
    if (itemIndex === -1) page.items.push(item);
    else {
      Vue.set(page.items, itemIndex, item);
    }
  });
};

const SET_PAGE_ITEM_ALL = (state, { view_id, page_id, body }) => {
  const view = state.myMaker.find((view) => view.view_id === view_id);
  if (!view) return;
  const page = view.pages.find((page) => page.page_id === page_id);
  if (!page) return;
  const itemList = viewItemFormatted(body);

  Vue.set(page, 'items', itemList);
};

const REMOVE_PAGE_ITEM = (state, { view_id, page_id, item_id }) => {
  const view = state.myMaker.find((view) => view.view_id === view_id);
  if (view) {
    const page = view.pages.find((page) => page.page_id === page_id);
    if (page) {
      const item_index = page.items.findIndex(
        (item) => item.item_id === item_id
      );
      if (item_index !== -1) page.items.splice(item_index, 1);
    }
  }
};

const UPDATE_PAGE_BACKGROUND = (state, { view_id, page_id, image_url }) => {
  const view = state.myMaker.find((view) => view.view_id === view_id);
  if (view) {
    const page = view.pages.find((page) => page.page_id === page_id);
    if (page) {
      Vue.set(page, 'page_image', image_url);
    }
  }
};

const SET_USER_IMAGES = (state, { images }) => {
  Vue.set(state.images, 'USER', images);
};

const SET_IMAGE_CATEGORIES = (state, { categories }) => {
  state.categories = categories;
};

const SET_CATEGORY_IMAGES = (state, { images, category_id }) => {
  Vue.set(
    state.images,
    category_id,
    images.subcategories.flatMap((sub) => sub.images)
  );
};

const REMOVE_PAGE_BACKGROUND = (state, { view_id, page_id }) => {
  const view = state.myMaker.find((view) => view.view_id === view_id);
  if (view) {
    const page = view.pages.find((page) => page.page_id === page_id);
    if (page) {
      Vue.set(page, 'page_image', null);
    }
  }
};

const SET_SHARE_USER = (state, { view_id, body }) => {
  const viewIndex = state.shareUser.findIndex(
    (view) => view.view_id === view_id
  );
  if (viewIndex === -1) {
    state.shareUser.push({
      view_id,
      users: Array.isArray(body) ? body : [body],
    });
  } else {
    if (Array.isArray(body)) {
      Vue.set(state.shareUser, viewIndex, { view_id, users: body });
    } else {
      const userIndex = state.shareUser[viewIndex].users.findIndex(
        (u) => u.user_id === body.user_id
      );
      if (userIndex === -1) state.shareUser[viewIndex].users.push(body);
    }
  }
};

const REMOVE_SHARE_USER = (state, { view_id, share_id }) => {
  const shareUser = state.shareUser.find((view) => view.view_id === view_id);
  if (shareUser) {
    const user_index = shareUser.users.findIndex(
      (users) => users.share_id === share_id
    );
    if (user_index !== -1) shareUser.users.splice(user_index, 1);
  }
};

const REMOVE_SHARE_VIEW = (state, { view_id }) => {
  const viewIndex = state.sharedMaker.findIndex(
    (view) => view.view_id === view_id
  );
  if (viewIndex !== -1) state.sharedMaker.splice(viewIndex, 1);

  const listIndex = state.sharedList.findIndex((v) => v.view_id === view_id);
  if (listIndex !== -1) state.sharedList.splice(listIndex, 1);
};

export default {
  SET_PROMISE,
  SET_SHARED_LIST,
  SET_MY_LIST,
  SET_SHARED_FULL_VIEW,
  SET_FULL_VIEW,
  SET_MY_VIEW,
  REMOVE_MY_VIEW,
  SET_VIEW_PAGE,
  REMOVE_VIEW_PAGE,
  SET_PAGE_ITEM,
  REMOVE_PAGE_ITEM,
  SET_PAGE_ITEM_ALL,
  SET_SHARE_USER,
  REMOVE_SHARE_USER,
  REMOVE_SHARE_VIEW,
  REMOVE_PAGE_BACKGROUND,
  UPDATE_PAGE_BACKGROUND,
  SET_USER_IMAGES,
  SET_IMAGE_CATEGORIES,
  SET_CATEGORY_IMAGES,
};
